
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {}
})
export default class DescModal extends Vue {
  visible: boolean = false

  data: {
    title: string
    content: string
  } | null = null

  get formatContent() {
    return this.data?.content.replaceAll(/\\n/g, '\n')
  }

  show(data: { title: string; content: string }) {
    if (!data) return

    this.data = data

    this.visible = true
  }

  hide() {
    this.visible = false
  }

  @Emit('closed')
  onClosed() {}

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
